import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import * as eventsService from '../services/eventsService';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiAlertCircle } = FiIcons;

/**
 * Handles single-segment slug URLs (e.g. /test-130-1pm).
 * Loads public event by event_slug and redirects to /landing/:eventId.
 * Relies on RLS allowing SELECT where status = 'public'.
 */
const SlugRedirect = () => {
  const { eventSlug } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    const redirect = async () => {
      if (!eventSlug) {
        setError('Event slug is required.');
        return;
      }

      const normSlug = (eventSlug && String(eventSlug).trim().toLowerCase()) || eventSlug;
      const { data, error: fetchError } = await eventsService.getPublicEventBySlug(normSlug);

      if (fetchError || !data) {
        setError(fetchError?.message || 'Event not found.');
        return;
      }

      navigate(`/landing/${data.id}`, { replace: true });
    };

    redirect();
  }, [eventSlug, navigate]);

  if (error) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center p-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-white rounded-2xl shadow-xl border border-slate-200 p-8 max-w-md w-full text-center"
        >
          <div className="w-16 h-16 bg-rose-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <SafeIcon icon={FiAlertCircle} className="w-8 h-8 text-rose-600" />
          </div>
          <h1 className="text-2xl font-bold text-slate-900 mb-2">Event Not Found</h1>
          <p className="text-slate-600 mb-6">{error}</p>
          <button
            onClick={() => navigate('/')}
            className="px-6 py-3 bg-slate-900 text-white rounded-lg hover:bg-slate-800 transition-colors font-medium"
          >
            Go to Home
          </button>
        </motion.div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl border border-slate-200 p-12 max-w-md w-full text-center">
        <div className="w-8 h-8 border-4 border-slate-200 border-t-slate-600 rounded-full animate-spin mx-auto mb-4" />
        <p className="text-slate-600">Redirecting to landing page...</p>
      </div>
    </div>
  );
};

export default SlugRedirect;
